<a class="av-skip" href="#main">{{ 'a11y.skip' | translate }}</a>
<av-consent-banner />
<av-header />
<main id="main" tabindex="-1">
  <router-outlet />
</main>
<av-footer />
